var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cf-tip">\n	<p>'+
((__t=( UpAct.lang.template('财富榜解释文案{area}',{area: UpAct.lang.template(areaName)},1) ))==null?'':__t)+
'</p>\n	<div class="cf-tip-btn">'+
((__t=( UpAct.lang.template('财富榜规则按钮{area}',{area: UpAct.lang.template(areaName)},1) ))==null?'':__t)+
'</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/component/send-hostList/tip.tmpl
// module id = 56
// module chunks = 0 1